<template>
  <div>
    <div class="thank-you-container">
      <p
        style="
          font-weight: 600;
          font-size: 35px;
          color: #00346b;
          margin: 0px 0px 20px;
          text-align: center;
        "
      >
        Thank you so much for your recent contribution to Bike NCSY Puerto Rico 2023. Your
        gift means so much to us.
      </p>
      <p style="margin: 0px 0px 20px">
        Israeli receipts are sent out twice a year in February and July. You can expect to
        receive the receipt by mail at that time.
      </p>
      <p style="margin: 0px 0px 20px">
        Words are not enough to express our appreciation for your help and support. Your
        generous contribution is being used to provide scholarships for Jewish teens who
        otherwise would not be able to afford to spend a gap year in Israel. Spending a
        year studying in Israel encompasses programming that encourages self-growth, focus
        on deep values and solidifies the teen's relationship to Judaism and to the land
        of Israel.
      </p>
      <p style="margin: 0px 0px 20px">
        Active in over 200 cities across North America, NCSY continues to connect, inspire
        and empower Jewish teens and encourage passionate Judaism through Torah and
        Tradition. NCSY Inspires Jewish teens and their connection to Israel through
        informal Jewish education, retreats and summer programs. NCSY empowers teens
        through leadership development and guidance to become passionately committed
        leaders of the Jewish community and instruments for positive change and renewal. A
        gap year in Israel is a great complement to these programs to foster an even
        greater lasting impact in our teens' jewish journeys.
      </p>
      <p style="margin: 0px 0px 20px">
        On behalf of all of our NCSY members and their families, thank you for your
        generosity and partnership. Your support is a great source of encouragement to us
        and loudly proclaims that we are one nation, supporting the next generation of
        Jewish leaders.
      </p>
      <p style="margin: 0px 0px 20px">
        Thank you for helping us bring so much to so many.
      </p>
      <p style="margin: 0px 0px 20px">Sincerely,</p>
      <p style="margin: 0px 0px 20px">
        Yehoshua Marchuck<br />
        Director, Bike NCSY<br />
        <a href="bike.ncsy.org">bike.ncsy.org</a>
      </p>
    </div>
  </div>
</template>
<style scoped>
.thank-you-container {
  padding: 20px;
  min-height: 300px;
  margin: 0 auto;
  background: #dff9e1;
  color: black;
  line-height: 1.4;
  font-weight: 400;
  text-align: left;
}
</style>
